import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {FlexView, Heading, Spacer, Spacing} from '/component/base/Storybook';

import ComponentTitle from './ComponentTitle';
import TextTitle from './TextTitle';

storiesOf('base', module).add('ProfileHeader', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Profile Header</Heading>
        <Spacer size={16} />
        <Text>
          Commonly in the app, ProfileHeader is used to display general info
          about person such as person's name, rank and photo.
        </Text>
        <Spacer size={16} />
        <TextTitle />
        <Spacer size={24} />
        <ComponentTitle />
      </FlexView>
    </Spacing>
  </ScrollView>
));
